module.exports = __webpack_public_path__ + "static/media/step4.b12bc657.png";